// extracted by mini-css-extract-plugin
export default {"tooltip":"bp-z","sharingV2":"cp-z","sharingIconsV2":"dp-z","links":"ep-z","link":"fp-z","facebookV2":"gp-z","twitterV2":"hp-z","pinterestV2":"ip-z"};